export default function AppVersion() {
    return (
        <span className="float-end me-3 font-monospace">
            v3.2.0
        </span>
    );
}